<template>
    <v-layout column>
        <v-layout justify-space-between align-center>
            <div class="ml-2 mb-1">Ledger Statement: </div>
            <v-btn
                data-testid="hide-statement-btn"
                class="hide-statement-btn error"
                small
                @click="hideStatement"
            >
              Hide Statement
            </v-btn>
        </v-layout>
        <v-flex>
            <v-data-table
                :items="ledgerStatement"
                :headers="headers"
                :options.sync="pagination"
                :footer-props="{'items-per-page-options': pagination.itemsPerPageOptions}"
            >
                <template slot="item" slot-scope="props">
                  <tr>
                    <td data-testid="statement-date">{{ formatDate(props.item.date) }}</td>
                    <td class="text-capitalize" data-testid="statement-type">{{ props.item.type }}</td>
                    <td data-testid="statement-description">{{ props.item.description }}</td>
                    <td data-testid="statement-amount">${{ parseFloat(props.item.amount).toFixed(2) }}</td>
                    <td data-testid="statement-tax">${{ parseFloat(props.item.tax).toFixed(2) }}</td>
                  </tr>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
/* eslint-disable eqeqeq */
import { ledgerStatementHeaders } from "@/helpers/tenant-rentals/ledger-statement-data-table-headers";
import moment from "moment";

export default {
  name: "LedgerStatement",
  props: {
    ledgerStatement: {
      type: Array
    }
  },
  data() {
    return {
      pagination: {
        itemsPerPage: 50,
        itemsPerPageOptions: [50, 100, 150, 200],
        totalItems: this.ledgerStatement.length,
        sortBy: ["date"],
        sortDesc: [true]
      },

      headers: ledgerStatementHeaders
    };
  },
  methods: {
    formatDate(date) {
      return moment.utc(date).format("MM/DD/YYYY");
    },

    hideStatement() {
      this.$emit("hideStatement");
    }
  }
};
</script>
